<template>
    <div v-if="editMode && !readOnly">
        <h2 class="vesselName">Fartøyets navn:</h2>
        <v-text-field
            ref="inputField"
            v-model="model"
            data-id="vessel-name-input"
            class="headline input-field"
            type="text"
            step="1"
            flat
            @change="updateValue(model)"
            @focus="onFocus"
            @blur="inFocus = false"
        />
    </div>

    <div v-else class="d-flex justify-center">
        <h2 v-if="!readOnly || (readOnly && !!model)" class="vesselName">Fartøyets navn: {{ model }}</h2>
        <v-btn v-if="!readOnly" variant="text" flat @click="toggleEditMode">
            <v-icon color="gray" size="24"> mdi-square-edit-outline </v-icon>
        </v-btn>
    </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, nextTick, watch } from 'vue';

const props = defineProps<{
    value?: string;
    readOnly: boolean;
}>();

const emit = defineEmits(['update']);

const editMode = ref(false);
const model = ref('');
const inFocus = ref(false);
const inputField = ref(null);

onMounted(() => {
    model.value = props.value;
    editMode.value = !model.value || model.value === '';
});

watch(
    () => props.value,
    (value: string) => {
        model.value = value;
    }
);

function updateValue(value: string) {
    editMode.value = false;
    emit('update', value);
}

function onFocus(event) {
    inFocus.value = true;
    event.target.select();
}

function toggleEditMode() {
    editMode.value = true;
    nextTick(() => inputField.value.input.el.querySelector('input').focus());
}
</script>

<style lang="scss">
.vesselName {
    text-align: center;
}

.input-field {
    max-width: 350px;
    margin: 0 auto;

    input {
        background-color: #ffffff;
    }
}
</style>
